module.exports = __webpack_public_path__ + "a5393cfd5a990795119b8afcf680b787.MP3";